module.exports = __webpack_public_path__ + "static/media/Bebas-Neue.813e6881.svg";